import React, { useEffect, useState } from 'react';
import { Image } from '@applane/react-core-components';
import ReactTooltip from 'react-tooltip';
import { View } from '../../../app-components';
import {
  crossIconPng,
  squareCloseFillIcon,
  squareCloseIcon,
} from '../../../images';
import { invoke } from '../../../AppServices';

const theme = {
  boxToHoldEverything: {
    padding: '2px 0px',
    width: 'inherit',
    overflowY: 'auto',
    marginLeft: 10,
  },
  boxToHoldElement: {
    fontSize: 20,
    margin: 10,
    backgroundColor: 'white',
  },
  boxToHoldTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    fontSize: 24,
    padding: '10px 0px',
    borderBottom: '1px solid black ',
  },
  boxToHoldX: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0px 15px',
    cursor: 'pointer',
    width: 20,
    height: 20,
  },
  boxToHoldXInvisible: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0px 15px',
    visibility: 'hidden',
  },
  boxToHoldEmpty: {
    height: '90%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 20,
    color: 'grey',
  },
  boxToHoldMakerName: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
  },
  boxToHoldMakerNameHover: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    backgroundColor: 'rgba(236,240,241,1)',
  },
  xIconProperties: {
    width: 'inherit',
    height: 'inherit',
  },
};

const GenerateDropdownList = ({ data }) => (
  <ul style={{ overflowY: 'auto', listStyleType: 'none' }}>
    {data.map((item, index) => (
      <li key={index} style={theme.boxToHoldElement}>
        <GenerateDropdownListButton
          makerName={item.makeName}
          modelArr={item.modelA}
        />
      </li>
    ))}
  </ul>
);

const generateSimpleList = (data) => (
  <ul
    style={{
      overflowY: 'auto',
      listStyleType: 'square',
      backgroundColor: 'white',
    }}
  >
    {data.map((item, index) => (
      <li key={index} style={theme.boxToHoldElement}>
        {item.name || item}
      </li>
    ))}
  </ul>
);

const generateEmptyList = () => (
  <View style={theme.boxToHoldEmpty}>No Data Available...</View>
);

const GenerateDropdownListButton = ({ makerName, modelArr }) => {
  const [expand, setExpand] = useState(false);
  const [hover, setHover] = useState(false);
  return (
    <View
      onMouseOver={() => setHover(true)}
      onFocus={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={hover ? theme.boxToHoldMakerNameHover : theme.boxToHoldMakerName}
      onClick={() => setExpand(!expand)}
    >
      {makerName}
      {expand && generateSimpleList(modelArr)}
    </View>
  );
};

const MakeModelList = ({ navigation }) => {
  const { title, item, ruleId } = navigation?.state?.params;
  const { carDetails } = item;
  const [data, setData] = useState([]);
  const [xHover, setXHover] = useState(false);

  const makeModelData = async (param) => {
    const fromBack = await invoke({
      id: 'makeModelData',
      paramValue: { ruleId: param },
    });
    setData(fromBack.result);
  };

  const listStyle = carDetails === 'Any' ? 'simple' : 'nested';

  useEffect(() => {
    if (carDetails === 'Any') {
      setData(['Any']);
    } else {
      makeModelData(ruleId);
    }
  }, [carDetails, ruleId]);

  return (
    <>
      <ReactTooltip
        place="bottom"
        type="dark"
        effect="float"
        id="list-close-button"
      />
      <View style={theme.boxToHoldTitle}>
        <View style={theme.boxToHoldXInvisible}>
          <Image source={crossIconPng} />
        </View>
        {title}
        <div data-tip="Close" data-for="list-close-button">
          <View
            style={theme.boxToHoldX}
            onMouseOver={() => setXHover(true)}
            onMouseLeave={() => setXHover(false)}
            onFocus={() => setXHover(true)}
            onClick={() => navigation.pop()}
          >
            <Image
              source={xHover ? squareCloseFillIcon : squareCloseIcon}
              style={theme.xIconProperties}
            />
          </View>
        </div>
      </View>
      {!data.length && generateEmptyList()}
      {data.length && (
        <>
          {listStyle === 'simple' && generateSimpleList(data)}
          {listStyle === 'nested' && GenerateDropdownList({ data })}
        </>
      )}
    </>
  );
};

export default MakeModelList;
